
export function persistCookies() {
	if (!document.cookie.includes('persistCookieDone=')) {
		// cookie not here, make call

		setTimeout(() => {
			fetch('/persistCookies').then( r => {
				// create cookie to exist for 1 day
				const d = new Date();
				d.setTime(d.getTime() + (24*60*60*1000));
				document.cookie = 'persistCookieDone=true;expires=' + d.toUTCString() + ';path=/';
			});
		}
		, 15000); // 15 second delay
	}
}